import AvatarIcon from '@pelckmans/elementis/components/avatar/avatar-icon';
import Breadcrumbs from '@pelckmans/elementis/components/breadcrumbs';
import LessonsIcon from '@pelckmans/elementis/icons/lessons';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useRoutes } from '../../../../hooks/useRoutes';

export default function SuperModuleLevelPageBreadcrumb() {
  const { t } = useTranslation();
  const { buildAbsolutePath } = useRoutes();
  const { subjectSlug, methodSlug, moduleSlug } = useParams();

  if (!subjectSlug || !methodSlug || !moduleSlug) return null;

  return (
    <Breadcrumbs.Item
      avatarIcon={<AvatarIcon icon={<LessonsIcon data-testid="lessons-icon" />} />}
      to={buildAbsolutePath(['MATERIAL'], {
        subjectSlug,
        methodSlug,
        moduleSlug,
      })}
    >
      {t('BREADCRUMBS.SUPER_MODULE_LEVEL_PAGE')}
    </Breadcrumbs.Item>
  );
}
